<template>
  <WdsButtonGhost
    secondary
    :href="path"
    :title="column?.name ?? ''"
    class="job-title-company-column"
  >
    <span class="job-title-company-column__name">
      {{ column?.name ?? '' }}
    </span>
  </WdsButtonGhost>
  <WdsText v-if="column?.company?.name" class="tw-pl-1">
    {{ column.company.name }}
  </WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsButtonGhost, WdsText } from '@worksome/wds-components'
import { graphql, FragmentType, useFragment } from '@/gql'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'

const frag = graphql(`
  fragment JobTitleCompanyColumn on Job {
    id
    name
    company {
      name
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof frag>
}>()

const column = computed(() => {
  if (!props.row) return null

  return useFragment(frag, props.row)
})

const path = computed(() => laravelNamedRoute('jobs.show', { job: column.value?.id }))
</script>

<style lang="scss">
.job-title-company-column {
  text-align: left;

  &__name {
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
